const BASE_API_DEV_UPLOAD = "https://api-colaborador.talentozeus-dev.com.mx";
const BASE_API_QA_UPLOAD = "https://api-colaborador.talentozeus-qa.com.mx";
const BASE_API_PROD_UPLOAD = "https://api-colaborador.talentozeus.com";

export const dev = {
  API_LOGIN: "https://api-empresa.talentozeus-dev.com.mx/auth/login",
  SEARCH_COLABORATOR: "https://api-colaborador.talentozeus-dev.com.mx/kiosko/collaboratorInfo",
  API_COLLABORATOR: "https://api-colaborador.talentozeus-dev.com.mx/",
  SCKey:
    "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA0QAd4NVUBTCVvCRNrU+4a7LO/0WgB8/r1MZ7T27hupyZQR76Wjd8sX4x6o2pcThEBAqneBhgUW/077JMCl8sKH4CssRPpZf44uBCcamOoLPLEQtWcNDoIKItpv9/ghjROqMx+zkBttRluCKU2CtD6j1p6WQ7pf31KdtKUQrjMZgwN7iaCv5Sm71TgzDJ8rMdKK0hI8NdWHVUNkItM1xpC69tBYjtJRKLs7D1fnHepIb3+hqVjD3Vr4lJT5cjXgAEORgLwgMc3D3gPeq8MqeI5gf77GDj1qk5yTIaRI43sOxVIaLrK05K5YVrkhASZIFFOFKtToizOnuEY3wy6rTkLwIDAQAB",
  FIREBASE_CONFIG: {
    apiKey: "AIzaSyC76BrdFl4xlpxYyiSQZi-FX3MhAfA5eoA",
    authDomain: "zeus-externos-dev.firebaseapp.com",
    projectId: "zeus-externos-dev",
    storageBucket: "zeus-externos-dev.appspot.com",
    messagingSenderId: "445168811485",
    appId: "1:445168811485:web:8c157b7ac70e2230254a34",
    measurementId: "G-HD9GR7ZRD4",
  },
  S3_BUCKET: "dev.zeus.files.app",
  API_UPLOAD: `${BASE_API_DEV_UPLOAD}`,
  HOST_PHOTOS: "https://files.talentozeus-dev.com.mx/",
};

export const qa = {
  API_LOGIN: "https://api-empresa.talentozeus-qa.com.mx/auth/login",
  SEARCH_COLABORATOR: "https://api-colaborador.talentozeus-qa.com.mx/kiosko/collaboratorInfo",
  API_COLLABORATOR: "https://api-colaborador.talentozeus-qa.com.mx/",
  SCKey:
    "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAmtAJGYDg28kpVMR5uEWtgoRoKOBQCkumlyed1qV0X/vQHDvCRXmAU6OCTigLlAa4JpaYMHX2QjUUotWKGMDGHJ/ud4gLVeyPDNWXGC5LDt/MXyBi/5ZuxhWlonbkNySPBfEVKLHh1Ku5HDFQRFKBpFptcEDVBwsP/GMqh+oVVWRo3s72vKU0HKQ3QYq6ylVIAdK9lOSA3IA8Hz70rE5opgfPOGB0ZkEtBnXfabX7hRerf3k/WpwslBen7xpoLUCzU6zkAHmzN9r7NH32ctBHhnNqFMdib44CL1IHAhJk0zB/BgYexHHNrSFxE4wRbihEcS6g260A4spCXeqFK/beEwIDAQAB",
  FIREBASE_CONFIG: {
    apiKey: "AIzaSyDQjCJZjOYWq1pPq2eBRljV7eKKMWG4uOg",
    authDomain: "zeus-externos-qa.firebaseapp.com",
    projectId: "zeus-externos-qa",
    storageBucket: "zeus-externos-qa.appspot.com",
    messagingSenderId: "1011340772543",
    appId: "1:1011340772543:web:d529ca12754e85eac6f20a",
    measurementId: "G-8ECRMCJQ86",
  },
  S3_BUCKET: "qa.zeus.files.app",
  API_UPLOAD: `${BASE_API_QA_UPLOAD}`,
  HOST_PHOTOS: "https://files.talentozeus-qa.com.mx/",
};

export const prod = {
  API_LOGIN: "https://api-empresa.talentozeus.com/auth/login",
  SEARCH_COLABORATOR: "https://api-colaborador.talentozeus.com/kiosko/collaboratorInfo",
  API_COLLABORATOR: "https://api-colaborador.talentozeus.com/",
  SCKey:
    "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA3L5vkeFIUWsx+/p2N/3EUpgHvZn0n90Cn21M0jCmhGitpTBChlEqlWG77qQvA7PgGMTpbcJF/rQPv3IFZQCrVLQbgE7afUP7oeSGceiIcTzDLlhp1xH96l1u2iSpf7Bf1LEXvV52RcQHyBKRYrrQPN/J6Msh56HRGXaY19/wwR0pw94gFwf2TRwf4ARlrfFxREVlpKzwkvd7hfy9YgW/K1UKmC+1Uo72g7C+rsXUus0NnPdTCvWW50rP2YRcFbIj4ZnJacsyZ93yVHGtlaAr//X5u+IZIfmhW7KIxWo0Osh7jnY26b9cwuh8+W/y/gvB4Pi7MdtAy13scV1JOFgXKwIDAQAB",
  FIREBASE_CONFIG: {
    apiKey: "AIzaSyA9av1KwpHHMeUjmrgcwFBu2ejV2r5ckdA",
    authDomain: "zeus-externos-prod.firebaseapp.com",
    projectId: "zeus-externos-prod",
    storageBucket: "zeus-externos-prod.appspot.com",
    messagingSenderId: "836760819489",
    appId: "1:836760819489:web:07a95d4a288bed59c89060",
    measurementId: "G-12NW1CK6XQ",
  },
  S3_BUCKET: "prod.zeus.files.app",
  API_UPLOAD: `${BASE_API_PROD_UPLOAD}`,
  HOST_PHOTOS: "https://files.talentozeus.com/",
};

export const test = dev;
